import { getMonth, getYear, parse } from 'date-fns';
import React, { useContext, useMemo } from 'react';
import { PopoverBody, UncontrolledPopover } from 'reactstrap';
import { rolesUnderCouncilMembers } from '../../services/constants';
import {
  FunnelFilterIcon,
  InfoCircleFilledIcon,
} from '../../services/SvgLibrary';
import styles from '../../styles/calendar/Calendar.module.scss';
import { CalendarContext } from '../calendar/CalendarContext';
import FilterAlertBadge from '../calendar/FilterAlertBadge';
const ProcReqFilters = ({
  children,
  statuses,
  setStatuses,
  changeProcRequestDisplay,
  changeProcRequestPopupWindow,
  getProcRequestCurrentMonthAndYear,
  sortByDateNeeded,
  setSortByDateNeeded,
  ...props
}) => {
  const { onSelectTime, currentMonth } = useContext(CalendarContext);

  const getNewCalendarData = e => {
    const parsedDate = parse(currentMonth, 'MMM yyyy', new Date());
    const inputMonth = getMonth(parsedDate);
    const inputYear = getYear(parsedDate);
    onSelectTime(
      e,
      getProcRequestCurrentMonthAndYear,
      inputMonth,
      inputYear,
      !sortByDateNeeded
    );

    setSortByDateNeeded(prev => !prev);
  };
  const filterOptions = [
    {
      key: 'pending',
      label: 'Pending',
      className: styles.pending,
      description: 'Proclamation request is under review for approval.',
    },
    {
      key: 'approved',
      label: 'Approved',
      className: styles.approved,
      description:
        'All required information has been received and the honoree has cleared vetting.',
    },
    {
      key: 'in-progress',
      label: 'In Progress',
      className: styles['in-progress'],
      description: 'Drafting of Proclamation Request in progress.',
    },
    {
      key: 'completed',
      label: 'Completed',
      className: styles.completed,
      description: 'The Proclamation Request is completed.',
    },
    {
      key: 'delivered',
      label: 'Delivered',
      className: styles.delivered,
      description: 'The Proclamation Request has been delivered.',
    },
    {
      key: 'withdrawn',
      label: 'Withdrawn',
      className: styles.withdrawn,
      description: 'Proclamation Request withdrawn.',
    },
  ];
  const defaultStatuses = {
    pending: true,
    approved: true,
    'in-progress': true,
    completed: true,
    delivered: true,
    withdrawn: true,
  };

  const isFilterChanged = useMemo(
    () =>
      Object.keys(defaultStatuses).some(
        key => statuses[key] !== defaultStatuses[key]
      ),
    [statuses]
  );
  return (
    <div style={{ marginLeft: 'auto', display: 'flex' }}>
      {React.Children.count(children) > 0 ? (
        children
      ) : (
        <>
          <button
            className={`btn dropdown-center ${styles['dropdown-filter-toggle']}`}
            type='button'
            data-bs-toggle='dropdown'
            aria-expanded='false'
            data-bs-auto-close='outside'
            title='Status Filter'>
            <FunnelFilterIcon />
            {isFilterChanged && <FilterAlertBadge />}
          </button>
          <ul className={`dropdown-menu ${styles['filter-dropdown-menu']}`}>
            <li>
              <h6 className='dropdown-header'>Select stage</h6>
            </li>
            {filterOptions.map(filter => (
              <li key={filter.key}>
                <label
                  className={`${styles['color-filter-container']} ${filter.className}`}>
                  {filter.label}
                  <input
                    type='checkbox'
                    checked={statuses[filter.key]}
                    onChange={() =>
                      setStatuses(prev => ({
                        ...prev,
                        [filter.key]: !prev[filter.key],
                      }))
                    }
                  />
                  <span
                    className={`${styles['color-filter-checkmark']} ${filter.className}`}></span>
                  <InfoCircleFilledIcon
                    classNameProp={styles['filter-popover-user-guide']}
                    idProp={filter.key}
                  />
                  <UncontrolledPopover
                    fade={false}
                    placement='bottom'
                    target={filter.key}
                    trigger='hover'>
                    <PopoverBody>
                      <div>
                        <b>{filter.label}:</b> {filter.description}
                      </div>
                    </PopoverBody>
                  </UncontrolledPopover>
                </label>
              </li>
            ))}
            {!rolesUnderCouncilMembers.includes(props.userProfile.role) && (
              <div>
                <li>
                  <hr className='dropdown-divider'></hr>
                </li>
                <li>
                  <p className='dropdown-header'>View Proclamations By</p>
                </li>
                <li>
                  <label
                    className={`${styles['color-filter-container']} ${styles['completed']}`}>
                    Date Proclamation is Needed
                    <input
                      type='checkbox'
                      checked={sortByDateNeeded}
                      onChange={e => getNewCalendarData(e)}
                    />
                    <span
                      className={`${styles['color-filter-checkmark']} ${styles['completed']}`}></span>
                  </label>
                </li>
                <li>
                  <label
                    className={`${styles['color-filter-container']} ${styles['completed']}`}>
                    Date of Event
                    <input
                      type='checkbox'
                      checked={!sortByDateNeeded}
                      onChange={e => getNewCalendarData(e)}
                    />
                    <span
                      className={`${styles['color-filter-checkmark']} ${styles['completed']}`}></span>
                  </label>
                </li>
              </div>
            )}
          </ul>
          <button
            className={`btn ${styles['create-report-button']}`}
            onClick={() => {
              changeProcRequestDisplay('create');
              changeProcRequestPopupWindow(true);
            }}>
            + New
          </button>
        </>
      )}
    </div>
  );
};
export default ProcReqFilters;
